import LocalityCreate from './LocalityCreate'
export {LocalityCreate}
export default LocalityCreate
